import { render, staticRenderFns } from "./lclAddonForm.vue?vue&type=template&id=61ffe69f&"
import script from "./lclAddonForm.vue?vue&type=script&lang=js&"
export * from "./lclAddonForm.vue?vue&type=script&lang=js&"
import style0 from "./lclAddonForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61ffe69f')) {
      api.createRecord('61ffe69f', component.options)
    } else {
      api.reload('61ffe69f', component.options)
    }
    module.hot.accept("./lclAddonForm.vue?vue&type=template&id=61ffe69f&", function () {
      api.rerender('61ffe69f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceLclAddon/components/lclAddonForm.vue"
export default component.exports